import { gql } from "@apollo/client";

export const PointLimitFragment = gql`
  fragment PointLimitFragment on PointLimit {
    id
    pointId
    limitId

    description
    dimensions
    limits

    createdAt
    updatedAt
  }
`;

export const get = gql`
  query PointLimitGet($pointId: String!, $limitId: String!) {
    viewer {
      id
      account {
        id
        points {
          id
          get(pointId: $pointId) {
            id
            limits {
              id
              get(limitId: $limitId) {
                ...PointLimitFragment
              }
            }
          }
        }
      }
    }
  }
  ${PointLimitFragment}
`;

export const list = gql`
  query PointLimitList($pointId: String!, $input: ListInput) {
    viewer {
      id
      account {
        id
        points {
          id
          get(pointId: $pointId) {
            id
            limits {
              id
              list(input: $input) {
                id
                last
                items {
                  ...PointLimitFragment
                }
              }
            }
          }
        }
      }
    }
  }
  ${PointLimitFragment}
`;




export const create = gql`
  mutation PointLimitNew($pointId: String!, $input: PointLimitInputCreate!) {
    viewer {
      account {
        points {
          get(pointId: $pointId) {
            limits {
              create(input: $input) {
                ...PointLimitFragment
              }
            }
          }
        }
      }
    }
  }
  ${PointLimitFragment}
`;

export const edit = gql`
  mutation PointLimitEdit($pointId: String!, $limitId: String!, $input: PointLimitInputUpdate!) {
    viewer {
      account {
        points {
          get(pointId: $pointId) {
            limits {
              get(limitId: $limitId) {
                update(input: $input) {
                  ...PointLimitFragment
                }
              }  
            }
          }
        }
      }
    }
  }
  ${PointLimitFragment}
`;

export const remove = gql`
  mutation PointLimitRemove($pointId: String!, $limitId: String!) {
    viewer {
      account {
        points {
          get(pointId: $pointId) {
            limits {
              get(limitId: $limitId) {
                remove
              }  
            }
          }
        }
      }
    }
  }

`;




export const update = ({ pointId }) => (cache) => {
  Object.keys(cache.data.data).forEach((key) => {
    if (key.includes(`${pointId}/limits/queries`)) {
      cache.data.delete(key);
    }
  });
};
